import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const COOKIE_KEY = "joborigo_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-4 pb-4 sm:px-6">
      <div className="max-w-3xl mx-auto bg-white dark:bg-brand-dark-surface border border-gray-200 dark:border-white/10 rounded-2xl shadow-xl px-5 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
            Joborigo uses essential cookies only — for authentication and session management. We do not use advertising or tracking cookies.{" "}
            <Link to="/privacy" className="text-brand-violet dark:text-brand-violet-on-dark hover:underline">
              Privacy Policy
            </Link>
          </p>
        </div>
        <button
          onClick={accept}
          className="flex-shrink-0 bg-brand-violet text-white px-5 py-2 rounded-lg text-sm font-medium hover:opacity-90 transition">
          Accept
        </button>
      </div>
    </div>
  );
}
